var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.473,
    height: 14.269,
    viewBox: "0 0 17.473 14.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.494,23.5a.165.165,0,0,0-.159.121L2,31.945v.291c0,.214-.014.291.165.291H15.2A.739.739,0,0,0,15.912,32l2.978-8.208V23.5Z",
    transform: "translate(-1.417 -18.258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.707,10.159H15.725V8.334a.8.8,0,0,0-.8-.8H7.721L6.265,5.5H.8a.8.8,0,0,0-.8.8V18.467l2.994-7.78A.739.739,0,0,1,3.707,10.159Z",
    transform: "translate(0 -5.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.52414901b8e4997faf540bfd8732bd35.svg";
export { ForwardRef as ReactComponent };